import {
  Layout, Button,
} from 'antd';
import styled from 'react-emotion';
import SplitPane from 'react-split-pane';
import {
  width, height, space, color, themeGet,
} from 'styled-system';
import LoadSpinnerOverlay from '../LoadSpinner';

export const Main = styled(Layout.Content)` &&& {
  display: block;
  border-bottom: 1px solid ${themeGet('colors.greyscale.3')};
  width: 100%;
  ${space}
  ${color}
  ${width}
  ${height}

  .DCRPArchivedData {
    opacity: .4;
  }

  #bktWrapper {
    height: calc(100% - 31px);

    .ReactVirtualized__Table__rowColumn {
      text-overflow: ellipsis;
      overflow: hidden !important;
    }

    .react-grid-HeaderCell-sortable {
      cursor: pointer;
    }
  }

  aside {
    float: right;
    position: relative;
  }

  .ant-row:first-child {
    height: 48px;
    min-height: 48px;
  }
}`;

export const Label = styled('span')`
  ${space}
  font-weight: bold;
  text-transform: capitalize;
`;

export const Loading = styled(LoadSpinnerOverlay)` &&& {
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: white;
}`;

export const SplitPanel = styled(SplitPane)` &&& {
  position: relative !important;
  height: 100vh !important;

  .Resizer {
    opacity: .6;
    z-index: 1;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -moz-background-clip: padding;
    -webkit-background-clip: padding;
    background-clip: padding-box;
  }

  .Resizer:hover {
    -webkit-transition: all .5s ease;
    transition: all .5s ease;
  }

  .Resizer.horizontal {
    height: 7px;
    margin: -3px 0;
    border-top: 3px solid rgba(255, 255, 255, 0);
    border-bottom: 3px solid rgba(255, 255, 255, 0);
    cursor: row-resize;
    width: 100%;
  }

  .Resizer.horizontal:hover {
      border-top: 3px solid rgba(0, 0, 0, 0.5);
      border-bottom: 3px solid rgba(0, 0, 0, 0.5);
  }
}`;


export const ModalButton = styled(Button)` &&& {
  margin-right: 12px;
}`;
